module.exports = __webpack_public_path__ + "media/images/athletes/66-41536ec74d0bbe4087333f01b03de893.png";